module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-BANDCAMP.c56fee38.png";